import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Lock, Mail, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-alabaster px-6 py-12"
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <p className="overline mb-3">PAINEL ADMINISTRATIVO</p>
          <h1 className="font-serif text-4xl text-onyx">Acesse Seu CMS</h1>
          <p className="mt-3 text-onyx/60 text-sm">
            Edite todo o conteúdo da landing page com facilidade.
          </p>
        </div>

        <form
          data-testid="admin-login-form"
          onSubmit={onSubmit}
          className="bg-white border border-border p-8 space-y-5"
        >
          <div>
            <label className="block text-xs tracking-[0.2em] uppercase text-onyx/60 mb-2">
              E-mail
            </label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-onyx/40" />
              <input
                data-testid="admin-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-10 pr-3 py-3 border border-border bg-alabaster text-onyx focus:outline-none focus:border-gold transition-colors"
                placeholder="admin@personaltrainer.com"
              />
            </div>
          </div>
          <div>
            <label className="block text-xs tracking-[0.2em] uppercase text-onyx/60 mb-2">
              Senha
            </label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-onyx/40" />
              <input
                data-testid="admin-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-3 py-3 border border-border bg-alabaster text-onyx focus:outline-none focus:border-gold transition-colors"
                placeholder="••••••••"
              />
            </div>
          </div>
          {error && (
            <p
              data-testid="admin-login-error"
              className="text-sm text-destructive bg-destructive/5 border border-destructive/20 px-3 py-2"
            >
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={submitting}
            className="w-full inline-flex items-center justify-center gap-3 py-3.5 bg-onyx text-alabaster text-xs tracking-[0.25em] uppercase font-semibold hover:bg-gold hover:text-onyx transition-colors disabled:opacity-50"
          >
            {submitting ? "Entrando…" : "Entrar"}
            <ArrowRight size={14} />
          </button>
        </form>

        <p className="mt-6 text-center text-xs text-onyx/40">
          <a href="/admin/forgot-password" data-testid="admin-forgot-link" className="hover:text-gold">
            Esqueci minha senha
          </a>
          <span className="mx-2 text-onyx/20">·</span>
          <a href="/" data-testid="admin-back-to-site" className="hover:text-gold">
            ← Voltar para a landing page
          </a>
        </p>
      </div>
    </div>
  );
}
